import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import OverLay from "./Modals/OverLay";
import { GlobalContext } from "../../Context/GlobalContext";
import { Paper } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import SendIcon from "@material-ui/icons/Send";
import FormInputs from "../TextFields/FormInputs";
import SnackBar from "./Notification/SnackBar";
import { getQueryVariable } from "../../Helpers/QueryString";

const ResetPassword = ({ companyName }) => {
  const API_URL = "https://310nwnmom8.execute-api.us-west-2.amazonaws.com";

  const [visible, setVisible] = useState(false);
  const [value, setValue] = useState({ newPassFirst: "", newPassSecond: "" });
  const [snack, setSnack] = useState({
    show: false,
    type: "error",
    message: "",
  });

  const { viewerObj, ownerOfVODId: publicUserId } = useContext(GlobalContext);

  const moveToHome = () => {
    window.location.href = window.location.href
      .split("/")
      .slice(0, -1)
      .join("/");
  };

  useEffect(() => {
    if (viewerObj) {
      moveToHome();
    }
  }, [publicUserId]);

  const handleSubmit = async () => {
    if (!value.newPassFirst || !value.newPassSecond) {
      setSnack({
        message: "Please enter password.",
        type: "error",
        show: true,
      });
    } else if (value.newPassFirst !== value.newPassSecond) {
      setSnack({
        message: "Password doesn't match.",
        type: "error",
        show: true,
      });
    } else {
      setVisible(true);
      const body = {
        ...value,
        email: getQueryVariable("email", window.location),
        token: getQueryVariable("token", window.location),
      };
      try {
        const { data, error } = await axios.post(`${API_URL}/update-password`, {
          ...body,
        });
        if (data) {
          setSnack({
            message: data?.message,
            type: "success",
            show: true,
          });
        }
        setTimeout(() => moveToHome(), 1000);
      } catch (error) {
        setSnack({
          message: error?.response?.data?.message,
          type: "error",
          show: true,
        });
      }
      setTimeout(() => setVisible(false), 200);
    }
  };

  return (
    <div className="main-container" style={{ textAlign: "center" }}>
      <OverLay visible={visible} loading={true} />
      <h3 className="title">Change Password</h3>
      <Paper elevation={5} style={styles.paper}>
        <FormInputs
          label={"New password *"}
          value={value.newPassFirst}
          onChange={(value) => {
            setValue((prev) => {
              return { ...prev, newPassFirst: value };
            });
          }}
          placeholder="Enter new password"
          type={"password"}
          required
        />
        <FormInputs
          label={"Repeat new password *"}
          value={value.newPassSecond}
          onChange={(value) => {
            setValue((prev) => {
              return { ...prev, newPassSecond: value };
            });
          }}
          placeholder="Repeat new password"
          type={"password"}
          required
        />
        <Button
          type="submit"
          disabled={visible}
          variant="contained"
          color="primary"
          size="large"
          onClick={handleSubmit}
          required
        >
          Update
          <SendIcon style={{ marginLeft: 5 }} />
        </Button>
      </Paper>
      <SnackBar
        open={snack.show}
        setOpen={(value) => {
          setSnack((prev) => {
            return { ...prev, message: "", type: "error", show: value };
          });
        }}
        type={snack.type}
        message={snack.message}
        verticalPosition={"top"}
        horizontalPosition={"right"}
      />
    </div>
  );
};

const styles = {
  paper: {
    position: "relative",
    margin: "auto",
    height: "100%",
    maxWidth: "800px",
    padding: "30px 20px 20px 20px",
  },
  snack: {
    width: "100%",
    "& > * + *": {
      // marginTop: theme.spacing(2),
    },
  },
};

export default ResetPassword;
